var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraOffline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66602 3.33008V7.99675C2.66602 10.9423 5.05382 13.3301 7.99935 13.3301C9.45482 13.3301 10.7741 12.7471 11.7364 11.8018M13.3327 3.33008V7.99675C13.3327 8.63568 13.2203 9.24837 13.0143 9.81614",
    stroke: "#FB462E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33301 3.33008H2.65842M14.6663 3.33008H7.99967H6.75408",
    stroke: "#FB462E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.41421 9.41061C8.63317 10.1917 7.36683 10.1917 6.58579 9.41061C5.80474 8.62956 5.80474 7.36323 6.58579 6.58218M8.78785 6.15753C9.01537 6.25493 9.22851 6.39648 9.41421 6.58218C9.62446 6.79242 9.77811 7.03783 9.87516 7.29947",
    stroke: "#FB462E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 1.66699L14 13.667",
    stroke: "#FB462E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraOffline);
export default __webpack_public_path__ + "static/media/camera_offline.34891d4c4f9b6653a693941451ae1f27.svg";
export { ForwardRef as ReactComponent };